import { useMemo } from 'react';

import get from 'lodash/get';
import useSWR from 'swr';

import { getNetworkSecurityGroups } from '../api';
import type { NetworkSelectOptionItem, UseNetworkSecurityGroupOptionsParams } from '../types';
import { mapNetworkSelectOptions } from '../utils';

export function useNetworkSecurityGroupOptions({ vpc, ws, dc, enabled = true }: UseNetworkSecurityGroupOptionsParams) {
  const swrKey = enabled && vpc && ws ? { key: 'NETWORK_SG_OPTIONS', vpc, ws, dc: dc ?? null } : null;

  const { data, error, isLoading } = useSWR(
    swrKey,
    ({ vpc: vpcName, ws: workspace, dc: datacenter }) => getNetworkSecurityGroups(vpcName, { ws: workspace, dc: datacenter ?? undefined }),
    { revalidateOnFocus: false },
  );

  const options = useMemo<NetworkSelectOptionItem[]>(() => {
    if (!data) return [];
    return mapNetworkSelectOptions(get(data, 'items', []), 'securitygroup');
  }, [data]);

  return { options, isLoading, error, isReady: !isLoading };
}
